import { Hammer, type LucideIcon } from "lucide-react";

export function SectionPlaceholder({
  icon: Icon,
  title,
  description,
  badge = true
}: {
  icon: LucideIcon;
  title: string;
  description: string;
  badge?: boolean;
}) {
  return (
    <section className="card section-placeholder">
      <div className="section-placeholder-icon"><Icon size={22}/></div>
      <h3>{title}</h3>
      <p>{description}</p>
      {badge && <span className="section-placeholder-badge"><Hammer size={12}/>Em construção</span>}
    </section>
  );
}
